/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-10-31 17:31:27
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-12-22 17:17:09
 * @Content:
 */

import { ISportType } from "./interface";

/**
 * 运动类型对应的中文
 */
export const SPORT_TYPE_LABEL_MAP: Record<ISportType, string> = {
  "0": "健走",
  "1": "跑步",
  "2": "骑行",
  "3": "滑雪",
  "4": "滑冰",
  "5": "登山",
  "101": "课程",
  "102": "动作",
};
